import {Data} from './data';
import { Plantarifaire } from './plantarifaire';
import { Produit } from './produit';
import { Taxe } from './taxe';

export class Partenaire extends Data {

    code: string;
    nom: string;
    tel: string;
    email: string;
    type_partenaire: string;
    pays: string;
    ville: string;
    adresse: string;
    montant: number;
    solde_compte_depot: number;
    reglements: number;
    plan_tarifaire: Plantarifaire;
    produits: Produit[];
    creance_limit: number;
    bp: string;
    num_contribuable: string;
    rc: string;

    cash_state_id: number;

    taxes: Taxe[];

    // Activated: boolean;

    constructor() {
        super(); // on appelle le constructeur du parent;
    }

    get reste(): number {
        if (this.montant  >= this.reglements)
        return this.montant - this.reglements;
        else
        return 0;
    }

    get resteNet(): number {

        if (this.solde_compte_depot === null || this.solde_compte_depot === undefined)
        return this.reste;

        if (this.solde_compte_depot >= this.reste)
        return 0;
        else
        return this.reste - this.solde_compte_depot;

    }

    /* get labelpartenaire(): string {
        return this.nom + ' - ' + this.type_partenaire;
    } */

    get labelPartenaire(): string {
        if (this !== null && this !== undefined)
        return  this.nom + ' - ' + this.type_partenaire;
        else
        return '';
    }

    get labelPlantarifaire() {

        if (this.plan_tarifaire !== null && this.plan_tarifaire !== undefined)
        return  this.plan_tarifaire.designation;
        else
        return 'Tarif normal';
    }


    get localisation(): string {

        let local = '';
        if (this.bp !== null && this.bp !== undefined)
        local += this.bp;

        if (this.adresse !== null && this.adresse !== undefined) {
            if (local !== '')
            local += ' - ' + this.adresse;
            else
            local += this.adresse;
        }

        if (this.ville !== null && this.ville !== undefined) {
            if (local !== '')
            local += ', ' + this.ville;
            else
            local +=  this.ville;
        }

        if (this.pays !== null && this.pays !== undefined) {

            if (local !== '')
            local += ', ' + this.pays;
            else
            local +=  this.pays;

        }

        return local;

    }

}
